import type { QueryFunctionContext } from '@tanstack/react-query';
import { AuthApi } from '@/entities/user/session/@x/access-rule';

export const useRulesQueryConfig = {
  queryKey: ['user-rules'],
  queryFn: async ({ signal }: QueryFunctionContext) => {
    const response = await AuthApi.getUserInterface({ signal, timeout: 15000 });
    if (response.status !== 200) {
      // throw new Error();
      return null;
    }
    return response.data;
  },
  // staleTime: Infinity,
  // cacheTime: Infinity,
  refetchOnMount: false,
  keepPreviousData: true,
  retry: false,
  cacheTime: 1000 * 60,
  // refetchInterval: 1000 * 60 * 2,
};
